import MuiTableContainer from "@mui/material/TableContainer";

export default function TableContainer(props) {
  return <MuiTableContainer {...props} />;
}
